import React from 'react';
import { addDoc, collection, serverTimestamp } from 'firebase/firestore';
import { db } from '../firebase-config';
import './RoatanQuizFunnel.css';

const robbieImg = 'https://www.roatan-realestate.com/wp-content/uploads/2025/05/Robbert-Hin-150.webp';

function SvgIcon({ className = '', children }) {
  return (
    <svg
      aria-hidden="true"
      className={className}
      fill="none"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      {children}
    </svg>
  );
}

function HomeIcon({ className = '' }) {
  return (
    <SvgIcon className={className}>
      <path d="M3 10.5 12 3l9 7.5" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.8" />
      <path d="M5.25 9.75v10.5h13.5V9.75" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.8" />
      <path d="M9.75 20.25v-5.25h4.5v5.25" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.8" />
    </SvgIcon>
  );
}

function WavesIcon({ className = '' }) {
  return (
    <SvgIcon className={className}>
      <path d="M3 15c1.5 0 1.5-2 3-2s1.5 2 3 2 1.5-2 3-2 1.5 2 3 2 1.5-2 3-2 1.5 2 3 2" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.8" />
      <path d="M3 19c1.5 0 1.5-2 3-2s1.5 2 3 2 1.5-2 3-2 1.5 2 3 2 1.5-2 3-2 1.5 2 3 2" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.8" />
    </SvgIcon>
  );
}

function MapPinIcon({ className = '' }) {
  return (
    <SvgIcon className={className}>
      <path d="M12 21s6-4.35 6-10.125a6 6 0 1 0-12 0C6 16.65 12 21 12 21Z" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.8" />
      <circle cx="12" cy="10.5" r="2.25" stroke="currentColor" strokeWidth="1.8" />
    </SvgIcon>
  );
}

function BuildingIcon({ className = '' }) {
  return (
    <SvgIcon className={className}>
      <path d="M4.5 20.25V6.75A2.25 2.25 0 0 1 6.75 4.5h10.5A2.25 2.25 0 0 1 19.5 6.75v13.5" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.8" />
      <path d="M9 20.25v-3.75h6v3.75M8.25 8.25h1.5m4.5 0h1.5M8.25 12h1.5m4.5 0h1.5" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.8" />
    </SvgIcon>
  );
}

function SailboatIcon({ className = '' }) {
  return (
    <SvgIcon className={className}>
      <path d="M12 4.5v10.5" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.8" />
      <path d="M12 4.5 7.5 13.5H12" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.8" />
      <path d="M12 6.75 18 15H12" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.8" />
      <path d="M4.5 18c1.25.9 2.5 1.35 3.75 1.35S10.75 18.9 12 18.9s2.5.45 3.75.45 2.5-.45 3.75-1.35" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.8" />
    </SvgIcon>
  );
}

function ChevronRightIcon({ className = '' }) {
  return (
    <SvgIcon className={className}>
      <path d="m9 6 6 6-6 6" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.8" />
    </SvgIcon>
  );
}

function CheckCircleIcon({ className = '' }) {
  return (
    <SvgIcon className={className}>
      <circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="1.8" />
      <path d="m8.5 12 2.3 2.3 4.7-4.8" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.8" />
    </SvgIcon>
  );
}

function DollarIcon({ className = '' }) {
  return (
    <SvgIcon className={className}>
      <path d="M12 3.75v16.5M15.75 7.5c0-1.243-1.679-2.25-3.75-2.25S8.25 6.257 8.25 7.5s1.679 2.25 3.75 2.25 3.75 1.007 3.75 2.25-1.679 2.25-3.75 2.25-3.75-1.007-3.75-2.25" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.8" />
    </SvgIcon>
  );
}

function PhoneIcon({ className = '' }) {
  return (
    <SvgIcon className={className}>
      <path d="M6.75 4.5h3l1.5 3.75-1.875 1.5a14.21 14.21 0 0 0 4.875 4.875l1.5-1.875L19.5 14.25v3A1.5 1.5 0 0 1 18 18.75h-.75C10.074 18.75 5.25 13.926 5.25 7.5v-.75A1.5 1.5 0 0 1 6.75 5.25V4.5Z" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.8" />
    </SvgIcon>
  );
}

function MailIcon({ className = '' }) {
  return (
    <SvgIcon className={className}>
      <path d="M4.5 6.75h15a1.5 1.5 0 0 1 1.5 1.5v7.5a1.5 1.5 0 0 1-1.5 1.5h-15A1.5 1.5 0 0 1 3 15.75v-7.5a1.5 1.5 0 0 1 1.5-1.5Z" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.8" />
      <path d="m4.5 8.25 7.5 5.25 7.5-5.25" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.8" />
    </SvgIcon>
  );
}

function UserIcon({ className = '' }) {
  return (
    <SvgIcon className={className}>
      <circle cx="12" cy="8.25" r="3" stroke="currentColor" strokeWidth="1.8" />
      <path d="M6 19.5c.9-2.7 3.15-4.5 6-4.5s5.1 1.8 6 4.5" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.8" />
    </SvgIcon>
  );
}

function PalmtreeIcon({ className = '' }) {
  return (
    <SvgIcon className={className}>
      <path d="M12 9.75c.75-2.55 2.7-4.2 5.25-4.5-1.2 2.4-2.775 3.825-5.25 4.5Zm0 0C10.95 7.2 9 5.55 6.75 5.25c1.2 2.4 2.775 3.825 5.25 4.5Zm0 0c2.55-.6 4.95-.15 7.5 1.5-2.55.45-4.95 0-7.5-1.5Zm0 0c-2.55-.6-4.95-.15-7.5 1.5 2.55.45 4.95 0 7.5-1.5Z" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.6" />
      <path d="M12 10.5v9.75M10.5 20.25h3" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.8" />
    </SvgIcon>
  );
}

function Card({ children, className = '' }) {
  return <div className={`roatan-card ${className}`.trim()}>{children}</div>;
}

function Button({ children, className = '', type = 'button', variant = 'solid', ...props }) {
  return (
    <button
      className={`roatan-button roatan-button--${variant} ${className}`.trim()}
      type={type}
      {...props}
    >
      {children}
    </button>
  );
}

function Progress({ value }) {
  return (
    <div className="roatan-progress" role="progressbar" aria-valuenow={Math.round(value)} aria-valuemin={0} aria-valuemax={100}>
      <div className="roatan-progress__bar" style={{ width: `${Math.max(0, Math.min(100, value))}%` }} />
    </div>
  );
}

function FormField({ icon: Icon, label, name, placeholder, type = 'text', value, onChange }) {
  return (
    <div className="roatan-field">
      <label className="roatan-label" htmlFor={name}>{label}</label>
      <div className="roatan-input-wrap">
        <Icon className="roatan-input-icon" />
        <input
          className="roatan-input"
          id={name}
          name={name}
          onChange={onChange}
          placeholder={placeholder}
          type={type}
          value={value}
        />
      </div>
    </div>
  );
}

function ResultCard({ type, answers, form }) {
  return (
    <Card className="roatan-result-card roatan-page">
      <div className="roatan-card-body roatan-card-body--result">
        <div className="roatan-avatar-wrap roatan-avatar-wrap--small">
          <img src={robbieImg} alt="Robbie Hin" className="roatan-avatar" />
        </div>

        <div className="roatan-pill">
          <CheckCircleIcon className="roatan-pill__icon" /> Quiz Complete
        </div>

        <h2 className="roatan-result-title">Thanks, {form.name || 'there'}!</h2>

        <p className="roatan-result-copy">
          Robbie Hin of RE/MAX Roatán Realty will personally review your responses and contact you within 24 hours with tailored property recommendations.
        </p>

        <div className="roatan-answer-grid">
          {answers.map((answer, index) => (
            <div key={`${answer}-${index}`} className="roatan-answer-card">
              <span className="roatan-answer-card__label">Answer {index + 1}:</span> {answer}
            </div>
          ))}
        </div>

        <div className="roatan-next-steps">
          <div className="roatan-next-steps__title">What happens next</div>
          <ul className="roatan-next-steps__list">
            <li>
              • {type === 'buyer'
                ? 'Personalized property matches based on your quiz answers'
                : 'A tailored selling strategy for your Roatán property'}
            </li>
            <li>• Local market insight from Robbie Hin</li>
            <li>• Follow-up to discuss your goals in Roatán</li>
          </ul>
        </div>
      </div>
    </Card>
  );
}

const buyerQuestions = [
  {
    question: 'What type of property are you looking for in Roatán?',
    options: ['Condo', 'Single-family home', 'Land / Lot', 'Not sure yet'],
    icon: HomeIcon,
    condition: null,
  },
  {
    question: 'How many bedrooms would you like?',
    options: ['1 bedroom', '2 bedrooms', '3 bedrooms', '4+ bedrooms'],
    icon: HomeIcon,
    condition: (answers) => {
      const propertyType = answers[0];
      return propertyType === 'Condo' || propertyType === 'Single-family home';
    },
  },
  {
    question: 'Do you want an ocean view?',
    options: ['Yes, must have ocean view', 'Nice to have', 'Not important', 'Open to options'],
    icon: WavesIcon,
    condition: null,
  },
  {
    question: 'How important is being close to the beach?',
    options: ['Walking distance is a must', 'Short drive is fine', 'Not important', 'Depends on the property'],
    icon: PalmtreeIcon,
    condition: null,
  },
  {
    question: 'What price range are you considering?',
    options: ['Under $250K', '$250K – $500K', '$500K – $1M', '$1M+'],
    icon: DollarIcon,
    condition: null,
  },
];

const sellerQuestions = [
  {
    question: 'What type of property are you selling?',
    options: ['Condo', 'Home', 'Land', 'Commercial / Other'],
    icon: BuildingIcon,
    condition: null,
  },
  {
    question: 'When are you hoping to sell?',
    options: ['ASAP', '1–3 months', '3–6 months', 'Just exploring'],
    icon: ChevronRightIcon,
    condition: null,
  },
  {
    question: 'Where is the property located?',
    options: ['West Bay', 'West End', 'Sandy Bay', 'Other area'],
    icon: MapPinIcon,
    condition: null,
  },
  {
    question: 'What is your main reason for selling?',
    options: ['Relocating', 'Investment exit', 'Upgrading / downsizing', 'Want to know market value'],
    icon: SailboatIcon,
    condition: null,
  },
];

export default function RoatanQuizFunnel({ agentConfig = {} }) {
  const [page, setPage] = React.useState('landing');
  const [flow, setFlow] = React.useState(null);
  const [step, setStep] = React.useState(0);
  const [answers, setAnswers] = React.useState([]);
  const [form, setForm] = React.useState({ name: '', email: '', phone: '' });
  const [error, setError] = React.useState('');
  const [submitting, setSubmitting] = React.useState(false);

  const questions = flow === 'buyer' ? buyerQuestions : sellerQuestions;
  const getVisibleQuestions = React.useCallback(
    (currentAnswers = answers) => questions.filter((question, index) => !question.condition || question.condition(currentAnswers.slice(0, index))),
    [answers, questions]
  );
  const visibleQuestions = flow ? getVisibleQuestions() : [];
  const currentQuestion = visibleQuestions[step];
  const profile = {
    name: agentConfig.name || 'Robbie Hin',
    company: agentConfig.company || 'RE/MAX Roatán Realty',
    email: agentConfig.email || 'robberthin@gmail.com',
    phone: agentConfig.phone || '+504-3300-0628',
    photo: agentConfig.photo || agentConfig.profileImage || robbieImg,
  };

  const resetToLanding = React.useCallback(() => {
    setPage('landing');
    setFlow(null);
    setStep(0);
    setAnswers([]);
    setForm({ name: '', email: '', phone: '' });
    setError('');
    setSubmitting(false);
  }, []);

  const resetQuiz = (nextFlow) => {
    setFlow(nextFlow);
    setStep(0);
    setAnswers([]);
    setForm({ name: '', email: '', phone: '' });
    setError('');
    setSubmitting(false);
    setPage('quiz');
  };

  const handleAnswer = (option) => {
    const nextAnswers = [...answers.slice(0, step), option];
    const nextVisibleQuestions = getVisibleQuestions(nextAnswers);

    setAnswers(nextAnswers);

    if (step + 1 < nextVisibleQuestions.length) {
      setStep(step + 1);
      setPage('quiz');
    } else {
      setPage('lead');
    }
  };

  const handleBack = () => {
    setError('');

    if (page === 'lead') {
      setPage('quiz');
      return;
    }

    if (step === 0) {
      resetToLanding();
      return;
    }

    setAnswers((prev) => prev.slice(0, -1));
    setStep((prev) => Math.max(prev - 1, 0));
  };

  const handleChange = (event) => {
    const { name, value } = event.target;
    setForm((prev) => ({ ...prev, [name]: value }));
    setError('');
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (!form.name.trim() || !form.email.trim()) {
      setError('Please enter your name and email.');
      return;
    }

    if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(form.email)) {
      setError('Please enter a valid email address.');
      return;
    }

    setSubmitting(true);

    try {
      await addDoc(collection(db, 'leads'), {
        agentId: 'robbiehin',
        agentName: profile.name,
        name: form.name.trim(),
        email: form.email.trim(),
        phone: form.phone.trim(),
        flowType: flow,
        answers: visibleQuestions.map((question, index) => ({
          question: question.question,
          answer: answers[index] || '',
        })),
        company: profile.company,
        timestamp: serverTimestamp(),
      });

      setPage('done');
    } catch (submitError) {
      console.error('Error saving Roatán lead:', submitError);
      setError('There was an error submitting your information. Please try again.');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="roatan-funnel">
      <div className="roatan-shell">
        {page === 'landing' && (
          <div className="roatan-page" key="landing">
            <Card className="roatan-card--landing">
              <div className="roatan-landing-grid">
                <div className="roatan-sidebar">
                  <div className="roatan-avatar-wrap roatan-avatar-wrap--large">
                    <img src={profile.photo} alt={profile.name} className="roatan-avatar" />
                  </div>
                  <h1 className="roatan-agent-name">{profile.name}</h1>
                  <p className="roatan-agent-company">{profile.company}</p>
                  <p className="roatan-agent-copy">Local guidance for buyers and sellers in Roatán, Honduras.</p>

                  <div className="roatan-contact-block">
                    <div>
                      <a href={`mailto:${profile.email}`} className="roatan-contact-link">
                        {profile.email}
                      </a>
                    </div>
                    <div>
                      <a href={`tel:${profile.phone.replace(/[^\d+]/g, '')}`} className="roatan-contact-link">
                        {profile.phone}
                      </a>
                    </div>
                  </div>
                </div>

                <div className="roatan-main-panel">
                  <div className="roatan-main-panel__inner">
                    <h2 className="roatan-hero-title">Find Your Perfect Roatán Property in 60 Seconds</h2>
                    <p className="roatan-hero-subtitle">Get handpicked homes based on your budget and lifestyle.</p>

                    <div className="roatan-benefits">
                      <div className="roatan-benefit-row">
                        <span className="roatan-benefit-dot">•</span>
                        <span>Beachfront &amp; ocean view homes</span>
                      </div>
                      <div className="roatan-benefit-row">
                        <span className="roatan-benefit-dot">•</span>
                        <span>Options for every budget</span>
                      </div>
                      <div className="roatan-benefit-row">
                        <span className="roatan-benefit-dot">•</span>
                        <span>Personalized local guidance</span>
                      </div>
                    </div>

                    <Button className="roatan-button--wide roatan-button--hero" onClick={() => resetQuiz('buyer')}>
                      Find My Property
                    </Button>

                    <Button className="roatan-button--wide roatan-button--seller" onClick={() => resetQuiz('seller')} variant="outline">
                      Sell My Property
                    </Button>
                  </div>
                </div>
              </div>
            </Card>
          </div>
        )}

        {page === 'quiz' && flow && currentQuestion && (
          <div className="roatan-page" key={`quiz-${flow}-${step}`}>
            <Card className="roatan-card--quiz">
              <div className="roatan-card-body">
                <div className="roatan-quiz-header">
                  <div>
                    <div className="roatan-eyebrow">{flow === 'buyer' ? 'Buyer quiz' : 'Seller quiz'}</div>
                    <h2 className="roatan-question-title">{currentQuestion.question}</h2>
                  </div>
                  <div className="roatan-step-copy">Step {step + 1} of {visibleQuestions.length}</div>
                </div>

                <div className="roatan-progress-wrap">
                  <Progress value={((step + 1) / visibleQuestions.length) * 100} />
                </div>

                <div className="roatan-option-grid">
                  {currentQuestion.options.map((option) => {
                    const QuestionIcon = currentQuestion.icon;

                    return (
                      <Button
                        key={option}
                        className="roatan-option-button"
                        onClick={() => handleAnswer(option)}
                        variant="outline"
                      >
                        <span className="roatan-option-button__content">
                          <span className="roatan-option-button__icon-wrap">
                            <QuestionIcon className="roatan-option-button__icon" />
                          </span>
                          <span>{option}</span>
                        </span>
                        <ChevronRightIcon className="roatan-option-button__chevron" />
                      </Button>
                    );
                  })}
                </div>

                <div className="roatan-quiz-footer">
                  <Button onClick={handleBack} variant="ghost">Back</Button>
                  <div className="roatan-footer-copy">Designed for Robbie Hin • RE/MAX Roatán Realty</div>
                </div>
              </div>
            </Card>
          </div>
        )}

        {page === 'lead' && (
          <div className="roatan-page" key="lead">
            <Card className="roatan-card--lead">
              <div className="roatan-card-body">
                <div className="roatan-lead-grid">
                  <div className="roatan-lead-aside">
                    <div className="roatan-avatar-wrap roatan-avatar-wrap--medium">
                      <img src={profile.photo} alt={profile.name} className="roatan-avatar" />
                    </div>
                    <div className="roatan-lead-title">Almost done</div>
                    <div className="roatan-lead-copy">Tell Robbie where to send your results.</div>
                  </div>

                  <form className="roatan-form" onSubmit={handleSubmit}>
                    <div className="roatan-form-grid">
                      <FormField
                        icon={UserIcon}
                        label="Name"
                        name="name"
                        onChange={handleChange}
                        placeholder="Your name"
                        value={form.name}
                      />
                      <FormField
                        icon={MailIcon}
                        label="Email"
                        name="email"
                        onChange={handleChange}
                        placeholder="you@example.com"
                        type="email"
                        value={form.email}
                      />
                    </div>

                    <FormField
                      icon={PhoneIcon}
                      label="Phone / WhatsApp"
                      name="phone"
                      onChange={handleChange}
                      placeholder="Optional"
                      value={form.phone}
                    />

                    {error ? <div className="roatan-error">{error}</div> : null}

                    <Button className="roatan-submit-button" disabled={submitting} type="submit">
                      {submitting ? 'Submitting...' : 'Get My Roatán Results'}
                    </Button>

                    <div className="roatan-note">Your information is sent securely to Robbie Hin for follow-up.</div>

                    <div className="roatan-lead-actions">
                      <Button onClick={handleBack} variant="ghost">Back</Button>
                    </div>
                  </form>
                </div>
              </div>
            </Card>
          </div>
        )}

        {page === 'done' && (
          <div className="roatan-page" key="done">
            <ResultCard type={flow} answers={answers} form={form} />
            <div className="roatan-start-over-wrap">
              <Button onClick={resetToLanding} variant="outline">Start Over</Button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}